import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../services/api';
import { debounce } from 'ts-debounce';

type Props = RouteComponentProps<{}>

type State = {
    results: GlobalSearchResult[];
    noResults: boolean;
}

type GlobalSearchResult = {
    Name: string;
    Link: string;
}

export default class MobileGlobalSearch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            results: [],
            noResults: false
        }
    }

    public render() {
        return <div>
            <input
                autoFocus
                type="text"
                className="form-control"
                onChange={(e) => this.searchDebounced(e.target.value)}
                autoComplete="off"
                placeholder="Search"
                aria-label="Search"
            />
            <ul className="list-group">
                {this.state.results.map((result, index) => {
                    return <Link
                        key={index}
                        to={result.Link}
                        className="list-group-item"
                    >
                        {result.Name}
                    </Link>
                })}
                {this.state.noResults && <li className="list-group-item disabled">No Results</li>}
            </ul>
        </div>
    }

    private searchDebounced = debounce(this.search, 250);

    private search(searchTerm: string) {
        if (searchTerm.length < 3) {
            this.setState({ results: [], noResults: false });
            return;
        }

        fetchApi('/api/Search/GlobalSearch', { SearchTerm: searchTerm }, 'POST')
            .then((results: GlobalSearchResult[]) => {
                this.setState({ results, noResults: results.length === 0 });
            });
    }
}
